import { combineReducers } from 'redux';
import sites from './sites';
import states from './states';
import subscription from './subscription';
import newspapers from './newspapers';
import newspaper from './newspaper';
import faq from './faq';
import termsOfUse from './termsOfUse';
import privacyPolicy from './privacyPolicy';
import messages from './messages';
import password from './password';
import session from './session';
import signup from './signup';
import creditCard from './creditCard';
import user from './user';
import campaigns from './campaigns';

export default combineReducers({
  sites,
  states,
  subscription,
  newspapers,
  newspaper,
  faq,
  termsOfUse,
  privacyPolicy,
  messages,
  password,
  session,
  signup,
  user,
  creditCard,
  campaigns,
});



// WEBPACK FOOTER //
// ./src/store/ducks/index.js